<template>
    <div class="af-form">
        <div
            class="afu-w-full afu-p-10 afu-bg-white afu-rounded-card afu-m-auto afu-w-100 afu-box-border"
            :class="{ 'afu-shadow-lg': !isModal }"
        >
            <div
                class="af-form"
                v-if="!submited"
            >
                <ValidationObserver
                    ref="saveSearchForm"
                    tag="form"
                    @submit.stop.prevent="onSubmit"
                >
                    <div v-show="!isLogin">
                        <ValidationProvider
                            name="email address"
                            rules="required|email"
                            v-slot="{ errors }"
                        >
                            <C1FormGroup>
                                <C1Label
                                    label-for="email address"
                                    class="afu-text-gray-700 afu-flex afu-justify-between"
                                >
                                    <span>{{ $t('label.email_address') }}</span>
                                </C1Label>

                                <C1FormInput
                                    id="email"
                                    v-model="form.email"
                                    :is-invalid="!!errors[0]"
                                    :invalid-feedback="errors[0]"
                                    name="email"
                                    type="email"
                                    :placeholder="$t('label.email_address')"
                                />
                            </C1FormGroup>
                        </ValidationProvider>
                    </div>

                    <div class="afu-my-4">
                        <ValidationProvider
                            name="name of alert"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <C1FormGroup>
                                <C1Label
                                    label-for="name of alert"
                                    class="afu-text-gray-700 afu-flex afu-justify-between"
                                >
                                    <span>{{ $t('label.alert_name') }}</span>
                                </C1Label>
                                <C1FormInput
                                    id="alertName"
                                    :is-invalid="!!errors[0]"
                                    :invalid-feedback="errors[0]"
                                    v-model="form.name"
                                    name="alertName"
                                    :placeholder="$t('label.alert_name')"
                                />
                            </C1FormGroup>
                        </ValidationProvider>
                    </div>

                    <C1FormGroup>
                        <div class="afu-my-4">
                            <C1Label
                                label-for="keywords"
                                class="afu-text-gray-700 afu-flex afu-justify-between"
                            >
                                <span>{{ $tc('label.keyword', 2) }}</span>
                            </C1Label>
                            <C1FormInput
                                id="search"
                                v-model="form.filter.search_keywords"
                                type="text"
                                placeholder="Keywords"
                            />
                        </div>
                        <div class="afu-my-4">
                            <C1Label
                                label-for="Classification"
                                class="afu-text-gray-700 afu-flex afu-justify-between"
                            >
                                <span>{{ $t('label.classification') }}</span>
                            </C1Label>
                            <ClassificationSelecter
                                label-inside="false"
                                @updateClassification="updateClassification"
                            />
                        </div>

                        <div class="afu-my-4">
                            <C1Label
                                label-for="Location"
                                class="afu-text-gray-700 afu-flex afu-justify-between"
                            >
                                <span>{{ $t('label.location') }}</span>
                            </C1Label>
                            <C1Typeahead
                                v-model="form.filter.location.label"
                                class="searchbar-typeahead w-100 afu-block focus:afu-outline-none afu-appearance-none afu-w-full afu-transition afu-duration-150 afu-ease-in-out afu-text-black afu-placeholder-custom afu-text-7xl afu-font-normal afu-bg-white afu-h-10"
                                :is-busy="spinner.location"
                                :options="locationOptions"
                                :no-icon="true"
                                :search-min-length="2"
                                label-key="label"
                                value-key="id"
                                filter-by="label"
                                :placeholder="$t('label.select_location')"
                                @search="searchLocations"
                                @hit="onLocationSelect"
                            >
                                <template slot="noResults">
                                    <div>
                                        No matching locations found.
                                    </div>
                                </template>
                            </C1Typeahead>
                        </div>

                        <C1FormGroup>
                            <C1Label
                                label-for="Salary Type"
                                class="afu-text-gray-700 afu-flex afu-justify-between"
                            >
                                <span>{{ $t('label.salary') }}</span>
                            </C1Label>
                            <ValidationProvider
                                v-slot="{ errors }"
                                name="Salary Type"
                                rules="required"
                            >
                                <C1Select
                                    v-model="salary.selectedType"
                                    label=""
                                    label-for="filterBySalary"
                                    :options="salary.types"
                                    placeholder="Select salary type"
                                    :is-invalid="!!errors[0]"
                                    :invalid-feedback="errors[0]"
                                />
                            </ValidationProvider>
                        </C1FormGroup>

                        <div v-if="isSelectedSalaryType">
                            <C1FormGroup>
                                <div class="afu-flex afu-items-start">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        name="min"
                                        rules="required|numeric|lessthan:@max"
                                    >
                                        <C1FormInput
                                            id="minSalary"
                                            v-model="salary.min"
                                            placeholder="Min"
                                            :is-invalid="!!errors[0]"
                                            :invalid-feedback="errors[0]"
                                            @input="updateSalary"
                                            @blur="updateSalary"
                                        >
                                            <template v-slot:icon>
                                                {{ $t('global.currency_symbol') }}
                                            </template>
                                        </C1FormInput>
                                    </ValidationProvider>
                                    <FontAwesomeIcon
                                        :icon="['fal', 'minus']"
                                        size="xs"
                                        class="afu-mx-2 afu-mt-4 afu-text-gray-400"
                                    />
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        name="max"
                                        rules="required|numeric|greaterthan:@min"
                                    >
                                        <C1FormInput
                                            id="maxSalary"
                                            v-model="salary.max"
                                            placeholder="Max"
                                            :is-invalid="!!errors[0]"
                                            :invalid-feedback="errors[0]"
                                            @input="updateSalary"
                                            @blur="updateSalary"
                                        >
                                            <template v-slot:icon>
                                                {{ $t('global.currency_symbol') }}
                                            </template>
                                        </C1FormInput>
                                    </ValidationProvider>
                                </div>
                            </C1FormGroup>
                        </div>

                        <div class="afu-my-4">
                            <SearchAttributesGroup
                                v-if="showCustomAttribute(1)"
                                attribute-code="applyflow_custom_1"
                                :attribute-label="getCustomLabel(1)"
                                :options="customAttributeOptions(1)"
                                @handleSelect="handleSelect"
                            />
                        </div>

                        <div class="afu-my-4">
                            <SearchAttributesGroup
                                v-if="showCustomAttribute(2)"
                                attribute-code="applyflow_custom_2"
                                :attribute-label="getCustomLabel(2)"
                                :options="customAttributeOptions(2)"
                                @handleSelect="handleSelect"
                            />
                        </div>

                        <div class="afu-my-4">
                            <SearchAttributesGroup
                                v-if="showCustomAttribute(3)"
                                attribute-code="applyflow_custom_3"
                                :attribute-label="getCustomLabel(3)"
                                :options="customAttributeOptions(3)"
                                @handleSelect="handleSelect"
                            />
                        </div>

                        <div class="afu-my-4">
                            <SearchAttributesGroup
                                v-if="showCustomAttribute(4)"
                                attribute-code="applyflow_custom_4"
                                :attribute-label="getCustomLabel(4)"
                                :options="customAttributeOptions('applyflow_custom_4')"
                                @handleSelect="handleSelect"
                            />
                        </div>
                    </C1FormGroup>

                    <C1FormGroup>
                        <C1Label
                            label-for="Frequency"
                            class="afu-text-gray-700 afu-flex afu-justify-between"
                        >
                            <span>{{ $t('label.frequency') }}</span>
                        </C1Label>
                        <Frequency
                            :current-frequency="form.frequency"
                            @updateFrequency="updateFrequency"
                        />
                    </C1FormGroup>

                    <AfTerms
                        v-if="!$_me.email"
                        :terms="getTerms"
                    />

                    <C1Alert
                        v-if="!!response.message"
                        :variant="response.variant"
                    >
                        <span v-html="response.message" />
                    </C1Alert>

                    <div class="afu-justify-center afu-flex afu-flex-wrap afu-gap-3">
                        <C1Button
                            :disabled="loader.updating"
                            :is-busy="loader.updating"
                            type="submit"
                            variant="outline-primary"
                            class="afu-w-btn-sm"
                        >
                            {{ $t('label.save') }}
                        </C1Button>
                        <C1Button
                            v-if="isModal"
                            variant="outline-primary"
                            class="afu-w-btn-sm"
                            @click.stop.prevent="close()"
                        >
                            {{ $t('label.cancel') }}
                        </C1Button>
                    </div>
                </ValidationObserver>
            </div>

            <div v-else>
                <C1Alert variant="success">
                    <p class="afu-text-center afu-mb-0">
                        {{ $t('job_alert.success') }}
                    </p>
                </C1Alert>
                <div class="afu-text-center afu-mt-5 md:afu-mt-10">
                    <a
                        :href="getLocalePath('/user-dashboard/job-alerts/')"
                        class="text-sm afu-text-primary-400 hover:afu-text-primary-400 afu-underline hover:afu-no-underline"
                    >
                        {{ $t('job_alert.manage') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import '@/plugins/vee-validate';
    import '../../plugins/vee-validate';
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import isEmpty from 'lodash/isEmpty';
    import C1Button from '@/components/C1Components/C1Button';
    import C1FormInput from '@/components/C1Components/C1FormInput';
    import C1Alert from '@/components/C1Components/C1Alert';
    import C1Select from '@/components/C1Components/C1Select';
    import C1FormGroup from '@/components/C1Components/C1FormGroup';
    import Frequency from '@/components/EmailAlerts/Frequency';
    import C1Label from '@/components/C1Components/C1Label';
    import ClassificationSelecter from '@/components/C1Components/ClassificationSelecter';
    import SearchAttributesGroup from '@/apps/search/001/components/SearchAttributesGroup';
    import C1Typeahead from '@/components/C1Components/C1Typeahead';
    // import C1CheckBox from '@/components/C1Components/C1CheckBox';
    import AfTerms from '@/components/Partials/AfTerms';

    export default {
        name: 'CreateJobAlert',

        components: {
            ValidationObserver,
            ValidationProvider,
            C1Label,
            C1Button,
            // C1CheckBox,
            C1FormInput,
            C1Alert,
            C1Select,
            C1FormGroup,
            Frequency,
            ClassificationSelecter,
            SearchAttributesGroup,
            C1Typeahead,
            AfTerms,
        },

        props: {
            isModal: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                response: {
                    variant: '',
                    message: '',
                },
                loader: {
                    updating: false,
                },
                attributeOptions: [],
                form: {
                    name: '',
                    email: '',
                    token: '',
                    frequency: 'DAILY',
                    filter: {
                        resultsPerPage: 20,
                        page: 1,
                        search_keywords: '',
                        location: {
                            label: '',
                        },
                        classifications: [],
                        pay_min: {},
                        pay_max: {},
                        applyflow_custom_1: [],
                        applyflow_custom_2: [],
                        applyflow_custom_3: [],
                        applyflow_custom_4: [],
                        null_pay_included: false,
                    },
                    search_url: null,
                },
                salary: {
                    types: [
                        {
                            id: 'annual_salary',
                            label: this.$t('label.annual_salary'),
                        },
                        {
                            id: 'hourly_rate',
                            label: this.$t('label.hourly_rate'),
                        },
                        {
                            id: 'per_day',
                            label: this.$t('label.per_day'),
                        },
                    ],
                    min: '',
                    max: '',
                    selectedType: {},
                    prefix: window?.afConfig?.currency || '$',
                },
                locationOptions: [],
                spinner: {
                    location: false,
                },
                submited: false,
            };
        },

        async created() {
            const urlParams = new URLSearchParams(window.location.search);
            const af_keyword = urlParams.get('af_keyword');
            if (af_keyword) {
                this.form.filter.search_keywords = af_keyword;
            }

            const af_location = urlParams.get('af_location');
            if (af_location) {
                this.form.filter.location.label = af_location;
            }

            const af_classification = urlParams.get('af_classification');
            if (af_classification) {
                this.updateClassification = urlParams.get('af_classification');
            }

            await this.$recaptchaLoaded();
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),

            isSelectedSalaryType() {
                return !isEmpty(this.salary.selectedType);
            },

            isLogin() {
                return this.$_me.email ? true : false;
            },

            getTerms() {
                let terms = window?.afConfig?.terms_content;
                if (terms) {
                    terms = JSON.parse(terms);
                } else {
                    terms = [];
                }
                return terms;
            },
        },

        watch: {
            '$_me.email': {
                handler() {
                    this.form.email = this.$_me.email;
                },
                deep: true,
            },
        },

        mounted() {
            this.getSiteAttributes();

            if (this.$_me.email) {
                this.form.email = this.$_me.email;
            }
        },

        methods: {
            ...mapActions('location', {
                $_getLocations: 'getLocations',
            }),

            ...mapActions('user', {
                $_saveJobAlert: 'saveJobAlert',
            }),

            ...mapActions('attribute', {
                $_getSiteAttributes: 'getSiteAttributes',
            }),

            async getSiteAttributes() {
                await this.$_getSiteAttributes().then(response => {
                    this.attributeOptions = response.data;
                });
            },

            customAttributeOptions(index) {
                return this.attributeOptions[`applyflow_custom_${index}`];
            },

            getCustomLabel(index) {
                return (
                    window.afConfig[`applyflow_custom_${index}_label`] ||
                    `Custom Label ${index}`
                );
            },

            showCustomAttribute(index) {
                if (window.afConfig[`applyflow_custom_${index}_show`]) {
                    return (
                        window.afConfig[`applyflow_custom_${index}_show`] === 'Yes'
                    );
                } else {
                    return false;
                }
            },

            updateClassification(classifications) {
                console.log(classifications);
                this.form.filter.classifications = classifications;
            },

            handleSelect(item) {
                this.form.filter[item.attribute] = item.selected;
            },

            searchLocations(str) {
                this.spinner.location = true;
                const keyword = str.toLowerCase();

                this.$_getLocations({ query: keyword }).then(res => {
                    const searchResults = res.data;
                    this.locationOptions = [...searchResults];
                    this.spinner.location = false;
                });
            },

            onLocationSelect(location) {
                this.form.filter.location = location;
            },

            updateFrequency(frequency) {
                this.form.frequency = frequency;
            },

            updateSalary() {
                if (this.salary.selectedType.id) {
                    this.form.filter.pay_min = {
                        value: this.salary.min,
                        pay_type_code: this.salary.selectedType.id,
                    };

                    this.form.filter.pay_max = {
                        value: this.salary.max,
                        pay_type_code: this.salary.selectedType.id,
                    };
                }
            },

            async onSubmit() {
                const validate = await this.$refs.saveSearchForm.validate();
                if (!validate) {
                    return;
                }

                const token = await this.$recaptcha('job_alert');
                if (!token) {
                    return;
                }

                this.loader.updating = true;
                this.form.token = token;
                const data = this.form;

                this.$_saveJobAlert(data)
                    .then(response => {
                        if (response) {
                            this.response.variant = 'success';
                            this.response.message = this.$t('job_alert.success');
                            this.$emit('jobAlertCreated');
                            this.submited = true;
                        }
                    })
                    .catch(() => {
                        this.response.message = this.$t('job_alert.error');
                        this.response.variant = 'danger';
                    })
                    .finally(() => {
                        this.loader.updating = false;
                    });
            },

            close() {
                this.$emit('jobAlertClose');
            },
        },
    };
</script>
<style lang="scss" scoped>
    .searchbar-typeahead {
        &::v-deep {
            .af-input-icon-x {
                top: 55%;
            }

            // .af-input {
            //     border: 0;
            // }
        }
    }
</style>
